import React from "react";
import withStyles from "@material-ui/styles/withStyles";
import { Button } from "@material-ui/core";

import { styles } from "./ReviseButton.styles";
import { useDispatch } from "react-redux";
import { billingRevise } from "../../../../reservationsSlice";

function ReviseButton({ classes, loading, reservationCode }) {
  const dispatch = useDispatch();

  const reviseHandler = () => {
    dispatch(billingRevise({ reservationCode }));
  };

  return (
    <div className={classes.root}>
      <Button
        className={classes.button}
        variant="outlined"
        color="primary"
        size="small"
        disabled={loading}
        onClick={reviseHandler}
      >
        Revise
      </Button>
    </div>
  );
}

export default withStyles(styles)(ReviseButton);
